module.exports = __webpack_public_path__ + "img/9-map.f8911f8a.jpg";